/* global axios */
import ApiClient from './ApiClient';

class BillingAPI extends ApiClient {
  constructor() {
    super('billing', { accountScoped: true });
  }

  getBilling() {
    return axios.get(this.url);
  }

  getPayments(page = 1) {
    return axios.get(`${this.url}/payments`, { params: { page } });
  }

  getCurrentInvoice() {
    return axios.get(`${this.url}/current_invoice`);
  }
}

export default new BillingAPI();
